import axios from 'axios';
import { CreateUserRequestBody, EmailTakenResponseBody, LoginResponseBody, MainConfigResponseBody, MainReportResponseBody, MainResponseBody, UpdateUserRequestBody, UserData } from '../util/model';
import { TokenService } from './token.service';

function getUrl(path?: string): string {
    const baseurl = '';
    if (path === undefined) {
        return baseurl;
    }
    return baseurl + path;
}

async function login(email: string, password: string) {
    return axios.post<LoginResponseBody>(getUrl('/api/rest/login/login'), {
        email, password
    });
}

async function main() {
    return axios.get<MainResponseBody>(getUrl('/api/rest/main'), {
        headers: {Authorization: `Bearer ${TokenService.getToken()}`}
    });
}

async function getReport(ReportName: string) {
console.log('report');
    return axios.post(
        getUrl('/api/rest/main/report'),
        {ReportName}, 
        {headers: {Authorization: `Bearer ${TokenService.getToken()}`}
    });
}

async function getConfig() {
    return axios.get<MainConfigResponseBody>(getUrl('/api/rest/main/config'), {
        headers: {Authorization: `Bearer ${TokenService.getToken()}`}
    });
}

async function updateConfig(body: MainConfigResponseBody) {
    return axios.put<MainConfigResponseBody>(
        getUrl('/api/rest/main/config'),
        body,
        {headers: {Authorization: `Bearer ${TokenService.getToken()}`}
    });
}

async function getUsers() {
    return axios.get<UserData[]>(getUrl('/api/rest/user'), {
        headers: {Authorization: `Bearer ${TokenService.getToken()}`}
    });
}

async function isEmailTaken(email: string) {
    return axios.post<EmailTakenResponseBody>(
        getUrl('/api/rest/user/isemailtaken'),
        {email}, 
        {headers: {Authorization: `Bearer ${TokenService.getToken()}`}
    });
}

async function createUser(body: CreateUserRequestBody) {
    return axios.post(getUrl('/api/rest/user'), body, {
        headers: {Authorization: `Bearer ${TokenService.getToken()}`}
    });
}

async function updateUser(id: string, body: UpdateUserRequestBody) {
    return axios.put(getUrl(`/api/rest/user/${id}`), body, {
        headers: {Authorization: `Bearer ${TokenService.getToken()}`}
    });
}

async function updateUserPassword(id: string, body: { password: string }) {
    return axios.put(getUrl(`/api/rest/user/${id}/password`), body, {
        headers: {Authorization: `Bearer ${TokenService.getToken()}`}
    });
}

async function deleteUser(id: string) {
    return axios.delete(getUrl(`/api/rest/user/${id}`), {
        headers: {Authorization: `Bearer ${TokenService.getToken()}`}
    });
}

async function activities(path:string,email:string) {
  return axios.post(getUrl(`/api/rest/activity`),{path,email}, {
    headers: { Authorization: `Bearer ${TokenService.getToken()}` },
  });
}

async function activitiesUpdate(path:string,params:string|null) {
  return axios.put(getUrl(`/api/rest/activity`),{path,params}, {
    headers: { Authorization: `Bearer ${TokenService.getToken()}` },
  })
}

async function activitiesSpentTimeEachUser(userId: string, ipAddress?: string) {
  return axios.get(getUrl(`/api/rest/activity/spent-time`), {
    params: {
      userId,
      ipAddress: ipAddress ? encodeURIComponent(ipAddress) : undefined,  // URL-encode ipAddress
    },
    headers: { Authorization: `Bearer ${TokenService.getToken()}` },
  });
}

async function allActivities(
  page: number, 
  pageSize: number, 
  activityType?: string, 
  userId?: string, 
  startDate?: Date, 
  endDate?: Date // Add endDate as an optional parameter
) {

  const params: { [key: string]: any } = {
    page,
    pageSize,
    ...(activityType && activityType !== "" && { activityType }), // Only add activityType if it's not an empty string
    ...(userId && { userId }), // Only add userId if provided
    ...(startDate && { startDate: encodeURIComponent(startDate.toISOString()) }), // URL-encode the startDate
    ...(endDate && { endDate: encodeURIComponent(endDate.toISOString()) }) // URL-encode the endDate if provided
  };

  // Make the GET request with the dynamic query parameters
  return axios.get(getUrl('/api/rest/activity'), {
    params,  // Automatically serializes the params to a query string
    headers: { Authorization: `Bearer ${TokenService.getToken()}` },
  });
}
const sleep = <In extends Array<any>, Out>(fn: (...args: In) => Out, timeout = 500) => async (...args: In): Promise<Out> => {
    const resultArray = await Promise.all([
        new Promise((res) => setTimeout(res, timeout)),
        fn(...args)
    ]);
    return resultArray[1];
};

export const RestApi = {
    login: sleep(login),
    main: sleep(main),
    activities: sleep(activities),
    activitiesSpentTimeEachUser: sleep(activitiesSpentTimeEachUser),
    activitiesUpdate: sleep(activitiesUpdate),
    allActivities: sleep(allActivities),
    getConfig: sleep(getConfig),
    updateConfig: sleep(updateConfig, 1000),
    getUsers: sleep(getUsers),
    isEmailTaken: sleep(isEmailTaken),
    createUser: sleep(createUser),
    updateUser: sleep(updateUser),
    updateUserPassword: sleep(updateUserPassword),
    deleteUser: sleep(deleteUser),
    getReport: sleep(getReport)
};
